"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toSeempleArray;

var _foreach = _interopRequireDefault(require("../_helpers/foreach"));

// converts array-like to Seemple.Array instance
function toSeempleArray(arrayLike) {
  // fix circular dependency issue
  var SeempleArray = require('./')["default"];

  var result = new SeempleArray(arrayLike.length);
  (0, _foreach["default"])(arrayLike, function (item, index) {
    result[index] = item;
  });
  return result;
}
//# sourceMappingURL=_toseemplearray.js.map